export default __webpack_public_path__ + "static/VictorMono-Regular-d76ae9388bbf1c2865aaae40548e66ff.woff2";